import Dot from '@webclient/components/search-forms/gamification-search/actions/filters/components/dot';
import StyledStack from '@webclient/components/search-forms/gamification-search/actions/filters/thoughtfulness/styles';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { setSearchModeByUserId } from '@webclient/state/slices/app-settings';
import { selectSearchMode } from '@webclient/state/slices/app-settings/userSettingSelector';

import AtomRoundedIcon from '~icons/knowz-iconify/atom-rounded';

import { Text, ToggleButton } from '@knowz/knowz-ui';

type ThoughtfulnessType = 'fluid' | 'advanced' | null;

export default function SearchModeTab() {
  const searchMode = useAppSelector(selectSearchMode);
  const me = useAppSelector((state) => state.auth.me);
  const dispatch = useAppDispatch();
  function handleChangeThoughfulness(
    _: React.MouseEvent<HTMLElement>,
    newVal: ThoughtfulnessType,
  ) {
    if (!me) return;
    if (newVal !== null) {
      switch (newVal) {
        case 'fluid':
          dispatch(
            setSearchModeByUserId({
              userId: me.uuid,
              searchMode: 'fluid',
            }),
          );
          break;
        case 'advanced':
          dispatch(
            setSearchModeByUserId({
              userId: me.uuid,
              searchMode: 'advanced',
            }),
          );
          break;
        default:
          newVal satisfies never;
          console.error('Invalid search mode');
      }
    }
  }

  return (
    <ToggleButton
      fullWidth
      exclusive
      value={searchMode}
      onChange={handleChangeThoughfulness}
    >
      <ToggleButton.Item
        fullWidth
        value="fluid"
      >
        <Text
          variant="textSm"
          weight="semibold"
        >
          <Dot visible={searchMode === 'fluid'} />
          &nbsp; Normal
        </Text>
      </ToggleButton.Item>
      <ToggleButton.Item
        fullWidth
        value="advanced"
      >
        <StyledStack>
          <Text
            variant="textSm"
            weight="semibold"
          >
            <Dot visible={searchMode === 'advanced'} />
            &nbsp; Genius
          </Text>
          <AtomRoundedIcon />
        </StyledStack>
      </ToggleButton.Item>
    </ToggleButton>
  );
}
